(function () {
  'use strict';

  // Append overlays to body — NOT to #header-component. The header element has
  // `contain: layout style` (Horizon's `.header` rule), which makes it a
  // containing block for position:fixed descendants. Overlays inside it would
  // be positioned relative to header-component's box (not viewport), breaking
  // both the initial state (overlay-top offset by topbar+announcement height)
  // and the sticky state (overlay-bottom clipped to header height).
  // Z-index is handled via CSS: overlays at z=3, .header-section at z=4
  // (--layer-heightened) or z=8 (--layer-sticky), so the header always paints
  // above overlays — including its mega menu — without needing to share stacking.
  let overlayTop = document.querySelector('.category-nav-overlay-top');
  let overlayBottom = document.querySelector('.category-nav-overlay-bottom');

  if (!overlayTop) {
    overlayTop = document.createElement('div');
    overlayTop.className = 'category-nav-overlay-top';
    document.body.appendChild(overlayTop);
  }
  if (!overlayBottom) {
    overlayBottom = document.createElement('div');
    overlayBottom.className = 'category-nav-overlay-bottom';
    document.body.appendChild(overlayBottom);
  }

  // Query directly the topbar element (its bottom = where main header starts).
  // overlay-top covers from y=0 to topbarBottom → dims announcement + topbar.
  // overlay-bottom covers from orange bar bottom to viewport bottom.
  const topbar = document.querySelector('.header-topbar');

  document.querySelectorAll('.category-nav__item--has-mega').forEach((item) => {
    const mega = item.querySelector('.category-nav__mega');
    if (!mega) return;

    const bar = item.closest('.header__category-bar');

    item.addEventListener('pointerenter', () => {
      const barRect = bar ? bar.getBoundingClientRect() : { bottom: 0 };
      const topbarRect = topbar ? topbar.getBoundingClientRect() : { bottom: 0 };
      // Clamp to >= 0: in sticky state, topbar is scrolled off-screen so its
      // viewport `bottom` is negative — we want overlay-top to collapse to 0.
      const navTop = Math.max(0, topbarRect.bottom);
      document.documentElement.style.setProperty('--nav-top', `${navTop}px`);
      document.documentElement.style.setProperty('--nav-bottom', `${barRect.bottom}px`);
      overlayTop.classList.add('is-visible');
      overlayBottom.classList.add('is-visible');
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      document.body.style.overflow = 'hidden';
    });

    item.addEventListener('pointerleave', () => {
      overlayTop.classList.remove('is-visible');
      overlayBottom.classList.remove('is-visible');
      document.body.style.paddingRight = '';
      document.body.style.overflow = '';
    });
  });
})();
